import Vue from 'vue'
import { Ability, AbilityBuilder } from '@casl/ability'
import { abilitiesPlugin } from '@casl/vue';

export default Object (() => {

    Vue.use(abilitiesPlugin, [], {
        useGlobalProperties: true
    });

    console.log(`🛡️ Contrôle d'habilitations Adelya activé`)
    return new Ability() 

})()

export function getRules(abilities) {
    const { can, rules } = new AbilityBuilder(Ability);
    can(abilities, 'all')
    return rules   
}